import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-page-no-access',
    templateUrl: './page-no-access.component.html',
    styleUrls: ['./page-no-access.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNoAccessComponent {

}
